var Mn = require('backbone.marionette'),
    scope = require('scope'),
    data = require('../data/default.json');

module.exports = Mn.AppRouter.extend({
    routes: {
        '(/)(index.html)': 'index',
        'resultado(/)(index.html)': 'result',
        'sucesso(/)(index.html)': 'contactSuccess'
    },
    index: function () {
        var View = require('views/Home');
        scope.setvars({});
        scope.app.go(new View());
    },
    result: function (slug) {
        var View = require('views/Result');
        // scope.setvars({});
        scope.app.go(new View({
            slug: slug
        }));
    },
    contactSuccess: function (slug) {
        var View = require('views/ContactSuccess');
        // scope.setvars({});
        scope.app.go(new View({}));
    }
});



// WEBPACK FOOTER //
// ./resources/scripts/routes/Main.js